import { Target } from 'redux-beacon';
import { mergeObjectDeep, getCustomWindowObject, setCustomWindowObject } from '@as-react/common-utils';
import { Options } from './types';

export const GA_EVENT_CRITEO = 'criteodata';

type DataLayer = Array<Record<string, unknown>>;

const checkIfCriteoEventIsAlreadyFired = (dataLayer: DataLayer) =>
  dataLayer.some(item => item.event === GA_EVENT_CRITEO);

const Criteo =
  ({
    windowVariableName = 'SITE.data.criteoPageObj',
    dataLayerName = 'dataLayer',
    pageTypeVariable = 'SITE.Config.analyticsPageType',
  }: Options = {}): Target =>
  events => {
    if (typeof window === 'undefined') {
      return;
    }

    let criteoPageObject = getCustomWindowObject(windowVariableName) as Record<string, unknown>;
    if (!criteoPageObject) {
      criteoPageObject = { ...mergeObjectDeep({}, ...events) };

      setCustomWindowObject(windowVariableName, criteoPageObject);
    }

    criteoPageObject = { ...mergeObjectDeep(criteoPageObject, ...events) };
    const pageType = getCustomWindowObject(pageTypeVariable);
    const dataLayer = (window as unknown as Record<string, unknown>)[dataLayerName] as DataLayer;
    let addEventToGoogleAnalytics = false;

    if (criteoPageObject.HashedEmail) {
      criteoPageObject.event = GA_EVENT_CRITEO;
      criteoPageObject.SiteType = /Mobi|Android/i.test(navigator.userAgent) ? 'm' : 'd';

      if (criteoPageObject.HashedEmail == 'anonymous') {
        criteoPageObject.HashedEmail = '';
      }

      switch (pageType) {
        case 'product':
        case 'cart':
        case 'brands':
        case 'search':
        case 'lister':
        case 'category':
          if (criteoPageObject.ProductID && checkIfCriteoEventIsAlreadyFired(dataLayer) === false) {
            addEventToGoogleAnalytics = true;
          }
          break;
        case 'purchase':
          if (
            criteoPageObject.ProductID &&
            criteoPageObject.TransactionID &&
            checkIfCriteoEventIsAlreadyFired(dataLayer) === false
          ) {
            addEventToGoogleAnalytics = true;
          }
          break;
        case 'home':
          if (checkIfCriteoEventIsAlreadyFired(dataLayer) === false) {
            addEventToGoogleAnalytics = true;
          }
          break;
        default:
          break;
      }
    }

    if (addEventToGoogleAnalytics) {
      dataLayer.push(criteoPageObject);

      setCustomWindowObject(windowVariableName, undefined);
    }
  };
export default Criteo;
